import React, { useState, useEffect } from 'react'
import './error-modal.scss'

const ErrorModal = () => {
  const [open, setOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    const handleShowErrorModal = (event) => {
      setErrorMessage(event.detail.message)
      setOpen(true)
    }

    document.addEventListener('showErrorModal', handleShowErrorModal)

    return () => {
      document.removeEventListener('showErrorModal', handleShowErrorModal)
    }
  }, [])

  const handleClose = () => {
    setOpen(false)
    setErrorMessage('')
  }

  if (!open) return null

  return (
    <section className='f-error-modal-curtain' onClick={handleClose} data-testid='modal-overlay'>
      <div className='f-error-modal-container' onClick={(e) => e.stopPropagation()}>
        <span className='f-close-modal-button' onClick={handleClose} data-testid='close-button' />
        <div className='f-error-content'>
          <i className='fas fa-exclamation-triangle f-error-icon' />
          <p className='f-error-message'>{errorMessage}</p>
        </div>
      </div>
    </section>
  )
}

export default ErrorModal
